// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-search[data-v-9bf74b68] {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.global-search .options[data-v-9bf74b68] {
  position: relative;
  display: flex;
  align-items: center;
  height: 52px;
  margin: 0.35em 0 0;
  overflow-x: auto;
  padding: 0 10px 6px 10px;
}
.global-search .options .option[data-v-9bf74b68] {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--search-input-bgcolor);
  border-radius: 24px;
  margin-right: 2px;
  min-width: 86px;
  height: 100%;
}
.global-search .options .option[data-v-9bf74b68]:hover,
.global-search .options .option.active[data-v-9bf74b68] {
  background-color: var(--search-option-bg-hover);
}
.global-search .options .option:hover .option-item[data-v-9bf74b68],
.global-search .options .option.active .option-item[data-v-9bf74b68] {
  color: var(--search-option-color-hover);
}
.global-search .options .option .option-item[data-v-9bf74b68] {
  display: flex;
  justify-content: center;
  font-size: 12px;
  color: var(--toolbtn-color);
  margin-bottom: -1px;
}
.global-search .list[data-v-9bf74b68] {
  overflow-y: auto;
  height: var(--calc-style);
}
.global-search .list .items[data-v-9bf74b68] {
  height: max-content;
}
.global-search .filter-more[data-v-9bf74b68] {
  display: flex;
  padding: 25px 0px;
  border-bottom: 1px solid var(--search-more-border);
  height: 71px;
}
.global-search .filter-more .filter-btns-main[data-v-9bf74b68] {
  display: flex;
  align-items: center;
  width: 80%;
  height: 100%;
  cursor: pointer;
}
.global-search .filter-more .filter-btns-main .filter-action[data-v-9bf74b68] {
  margin-left: 14px;
}
.global-search .filter-more .filter-btns-main .filter-action i[data-v-9bf74b68] {
  font-size: 18px;
  margin-right: 10px;
  margin-top: 3px;
  color: var(--toolbtn-color);
}
.global-search .filter-more .filter-btns-main .title[data-v-9bf74b68] {
  color: var(--toolbtn-color);
  font-size: 16px;
  font-weight: 400;
  margin-top: 2px;
}
.global-search .filter-more .filter-btns-main .info[data-v-9bf74b68] {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.global-search .filter-more .filter-btns-main .filter-subtitle[data-v-9bf74b68] {
  max-width: 264px;
  margin-left: 5px;
  color: var(--base-blue-color);
}
.global-search .filter-more .filter-btns-right .filter-close[data-v-9bf74b68] {
  margin-left: 5px;
  position: absolute;
  right: 0;
  margin-right: 20px;
  color: var(--toolbtn-color);
  opacity: 1;
  margin-top: 2px;
}
.global-search .filter-more .filter-btns-right .filter-close .fa[data-v-9bf74b68] {
  font-size: 21px;
  display: block;
  font-weight: 100;
  color: var(--toolbtn-color);
}
.global-search .scroller[data-v-9bf74b68] {
  position: relative;
  overflow-x: hidden;
  width: 100%;
  margin-bottom: 0px !important;
}
.global-search .scroller[data-v-9bf74b68] .resize-observer {
  height: 0;
}
.global-search .scroller[data-v-9bf74b68] .resize-observer object {
  height: 0;
}
.global-search .scroller[data-v-9bf74b68] .vue-recycle-scroller__item-wrapper .listItem {
  height: 0;
  width: 100%;
}
.global-search .scroller[data-v-9bf74b68] .vue-recycle-scroller__item-wrapper .listItem .section-title {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  height: 45px;
}
.global-search .scroller[data-v-9bf74b68] .vue-recycle-scroller__item-wrapper .listItem .section-title .title-text {
  padding-left: 3.3em;
  font-size: medium;
  color: #337ab7;
}
.global-search .scroller[data-v-9bf74b68] .vue-recycle-scroller__item-wrapper .listItem .load-more {
  display: flex;
  align-items: center;
  justify-content: end;
  height: 45px;
}
.global-search .scroller[data-v-9bf74b68] .vue-recycle-scroller__item-wrapper .listItem .load-more .load-more-btn {
  font-size: 1em;
  color: var(--toolbtn-color);
  margin: 0 0.4em;
  padding: 0.4em 0.75em 0.4em;
  border-radius: 24px;
  background-color: var(--search-input-bgcolor);
}
.global-search .scroller[data-v-9bf74b68] .vue-recycle-scroller__item-wrapper .listItem .load-more .load-more-btn:hover {
  cursor: pointer;
  background-color: #153f62;
}
.global-search[data-v-9bf74b68] .loader {
  position: absolute !important;
  height: 100%;
  background-color: #151e2759;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/search/GlobalSearch.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,kDAAkD;EAClD,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,2BAA2B;EAC3B,UAAU;EACV,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,2BAA2B;AAC7B","sourcesContent":[".global-search[data-v-9bf74b68] {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.global-search .options[data-v-9bf74b68] {\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 52px;\n  margin: 0.35em 0 0;\n  overflow-x: auto;\n  padding: 0 10px 6px 10px;\n}\n.global-search .options .option[data-v-9bf74b68] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--search-input-bgcolor);\n  border-radius: 24px;\n  margin-right: 2px;\n  min-width: 86px;\n  height: 100%;\n}\n.global-search .options .option[data-v-9bf74b68]:hover,\n.global-search .options .option.active[data-v-9bf74b68] {\n  background-color: var(--search-option-bg-hover);\n}\n.global-search .options .option:hover .option-item[data-v-9bf74b68],\n.global-search .options .option.active .option-item[data-v-9bf74b68] {\n  color: var(--search-option-color-hover);\n}\n.global-search .options .option .option-item[data-v-9bf74b68] {\n  display: flex;\n  justify-content: center;\n  font-size: 12px;\n  color: var(--toolbtn-color);\n  margin-bottom: -1px;\n}\n.global-search .list[data-v-9bf74b68] {\n  overflow-y: auto;\n  height: var(--calc-style);\n}\n.global-search .list .items[data-v-9bf74b68] {\n  height: max-content;\n}\n.global-search .filter-more[data-v-9bf74b68] {\n  display: flex;\n  padding: 25px 0px;\n  border-bottom: 1px solid var(--search-more-border);\n  height: 71px;\n}\n.global-search .filter-more .filter-btns-main[data-v-9bf74b68] {\n  display: flex;\n  align-items: center;\n  width: 80%;\n  height: 100%;\n  cursor: pointer;\n}\n.global-search .filter-more .filter-btns-main .filter-action[data-v-9bf74b68] {\n  margin-left: 14px;\n}\n.global-search .filter-more .filter-btns-main .filter-action i[data-v-9bf74b68] {\n  font-size: 18px;\n  margin-right: 10px;\n  margin-top: 3px;\n  color: var(--toolbtn-color);\n}\n.global-search .filter-more .filter-btns-main .title[data-v-9bf74b68] {\n  color: var(--toolbtn-color);\n  font-size: 16px;\n  font-weight: 400;\n  margin-top: 2px;\n}\n.global-search .filter-more .filter-btns-main .info[data-v-9bf74b68] {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n.global-search .filter-more .filter-btns-main .filter-subtitle[data-v-9bf74b68] {\n  max-width: 264px;\n  margin-left: 5px;\n  color: var(--base-blue-color);\n}\n.global-search .filter-more .filter-btns-right .filter-close[data-v-9bf74b68] {\n  margin-left: 5px;\n  position: absolute;\n  right: 0;\n  margin-right: 20px;\n  color: var(--toolbtn-color);\n  opacity: 1;\n  margin-top: 2px;\n}\n.global-search .filter-more .filter-btns-right .filter-close .fa[data-v-9bf74b68] {\n  font-size: 21px;\n  display: block;\n  font-weight: 100;\n  color: var(--toolbtn-color);\n}\n.global-search .scroller[data-v-9bf74b68] {\n  position: relative;\n  overflow-x: hidden;\n  width: 100%;\n  margin-bottom: 0px !important;\n}\n.global-search .scroller[data-v-9bf74b68] .resize-observer {\n  height: 0;\n}\n.global-search .scroller[data-v-9bf74b68] .resize-observer object {\n  height: 0;\n}\n.global-search .scroller[data-v-9bf74b68] .vue-recycle-scroller__item-wrapper .listItem {\n  height: 0;\n  width: 100%;\n}\n.global-search .scroller[data-v-9bf74b68] .vue-recycle-scroller__item-wrapper .listItem .section-title {\n  display: flex;\n  align-items: center;\n  margin-bottom: 25px;\n  height: 45px;\n}\n.global-search .scroller[data-v-9bf74b68] .vue-recycle-scroller__item-wrapper .listItem .section-title .title-text {\n  padding-left: 3.3em;\n  font-size: medium;\n  color: #337ab7;\n}\n.global-search .scroller[data-v-9bf74b68] .vue-recycle-scroller__item-wrapper .listItem .load-more {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  height: 45px;\n}\n.global-search .scroller[data-v-9bf74b68] .vue-recycle-scroller__item-wrapper .listItem .load-more .load-more-btn {\n  font-size: 1em;\n  color: var(--toolbtn-color);\n  margin: 0 0.4em;\n  padding: 0.4em 0.75em 0.4em;\n  border-radius: 24px;\n  background-color: var(--search-input-bgcolor);\n}\n.global-search .scroller[data-v-9bf74b68] .vue-recycle-scroller__item-wrapper .listItem .load-more .load-more-btn:hover {\n  cursor: pointer;\n  background-color: #153f62;\n}\n.global-search[data-v-9bf74b68] .loader {\n  position: absolute !important;\n  height: 100%;\n  background-color: #151e2759;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
